<template>
  <div class="web-carousel">
    <el-carousel
      height="500px"
      trigger="click"
      :interval="4000"
      :autoplay="autoPlay"
    >
      <el-carousel-item
        v-for="item in list"
        :key="item.id"
      >
        <div
          :class="['div-img', (item.contentId || item.link || item.video) && 'link']"
          :style="{background: `url('${item.image}') no-repeat center center`}"
          @click="onClickItem(item)"
        />
      </el-carousel-item>
    </el-carousel>
    <el-dialog
      :close-on-click-modal="false"
      :destroy-on-close="true"
      :append-to-body="true"
      class="video-dialog"
      width="750px"
      :visible.sync="videoParam.visible"
      @close="videoParam.visible = false"
    >
      <div
        v-if="videoParam.visible"
      >
        <video-play
          :video-url="videoParam.url"
          :video-name="videoParam.name"
          video-width="100%"
          video-height="100%"
        />
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { openUrl } from '../../../../../lib/utils';

export default {
    name: 'Carousel',
    props: {
        list: {
            type: Array,
            default: () => [],
        },
    },
    data () {
        return {
            videoParam: {
                visible: false,
                url: '',
                name: '',
            },
        };
    },
    computed: {
        docmentHidden () {
            return this.$store.getters['system/getDocmentHidden'];
        },
        autoPlay () {
            return !this.videoParam.visible && !this.docmentHidden;
        },
    },
    methods: {
        onClickItem (item) {
            if (!this.web3YxpNav) {
                this.web3YxpNav = document.querySelector('.web003-nav-popover');
            }
            if (this.web3YxpNav && this.web3YxpNav.style.display !== 'none') return;
            if (item.link) {
                openUrl(item.link);
            } else if (item.video) {
                Object.assign(this.videoParam, {
                    visible: true,
                    url: item.video,
                });
            } else if (item.contentId) {
                const query = this.$route.query;
                const routeUrl = this.$router.resolve({
                    path: '/webModulePage/articleDetail',
                    query: {
                        contentId: item.contentId,
                        siteId: query.siteId,
                        from: 'home',
                    },
                });
                openUrl(routeUrl.href);
            }
        },
    },
};
</script>
<style lang="scss">
$color: #2693F1;
.video-dialog {
    .el-scrollbar__wrap {
        overflow-x: hidden;
        overflow-y: auto;
    }
    .el-button--primary {
        background-color: $color;
        border-color: $color;
    }
    .el-dialog__headerbtn:focus .el-dialog__close, .el-dialog__headerbtn:hover .el-dialog__close {
        color: $color;
    }
}
</style>
<style scoped lang="scss">
.web-carousel {
    width: 100%;
    height: 500px;
    position: relative;
    background-color: #f5f5f7;
    .div-img {
        width: 100%;
        height: 100%;
        &.link {
            cursor: pointer;
        }
    }
    ::v-deep .el-carousel__item.is-animating {
        transition: transform .8s ease-in-out,-webkit-transform .8s ease-in-out;
    }
}
</style>
